export const captainLabel = "Ambassador";
export const participantLabel = "Participant";